import { Button, ButtonGroup } from '@chakra-ui/react';
import moment from 'moment';
import { Mixpanel } from 'services/mixpanel';
import { getInvoiceUrl } from 'services/order';
import { pdfDownload } from 'shared/helpers/pdfDownload';
import { usePermissions } from 'shared/hooks/usePermissions';
import { orderStatus } from 'shared/models/order';
import { useOrderModalContext } from '../ModalContext';

const OrderActions = () => {
  const {
    editing,
    startEditing,
    loading,
    order,
    abortEditing,
    processPayment,
    cancelOrder,
    generateOrderInvoice,
    downloadDanfse,
    downloadXml,
    sendEmail,
    reverseOrder,
  } = useOrderModalContext();
  const { e } = usePermissions();

  const canReverse =
    order?.statusId === orderStatus.PAGO &&
    e('order-reversal') &&
    !!order?.due_date &&
    moment().diff(order.due_date, 'months') < 12;

  const downloadInvoice = async () => {
    Mixpanel.track('customers-financial-order-clicked-download-invoice');
    if (order?.hasInvoiceLink && order.id) {
      try {
        const { data } = await getInvoiceUrl(order.id);
        await pdfDownload(data.url);
      } catch (error) {
        console.error('Erro ao baixar boleto:', error);
      }
    }
  };

  return order?.statusId !== orderStatus.CANCELADO &&
    order?.statusId !== orderStatus.PAGO ? (
    <ButtonGroup size="sm" variant="filled" mt="1rem" isDisabled={loading}>
      {editing ? (
        <>
          <Button variant="outlined" onClick={abortEditing}>
            Cancelar Edição
          </Button>
        </>
      ) : (
        <>
          {!order?.invoice && !order?.invoices.length && (
            <Button onClick={startEditing}>Editar Cobrança</Button>
          )}

          {order?.canGenerateInvoice && (
            <Button onClick={generateOrderInvoice}>Gerar boleto</Button>
          )}

          {order?.hasInvoiceLink && (
            <Button onClick={downloadInvoice}>Baixar boleto</Button>
          )}

          {order?.bankId === 1 && order.statusId === 1 && (
            <Button onClick={processPayment}>Retentar Cobrança</Button>
          )}

          <Button onClick={cancelOrder}>Cancelar Cobrança</Button>
        </>
      )}
    </ButtonGroup>
  ) : order?.statusId === orderStatus.PAGO ? (
    <ButtonGroup size="sm" variant="filled" mt="1rem" isDisabled={loading}>
      {order?.nfse?.accessKey && (
        <>
          <Button onClick={downloadDanfse}>Baixar DANFSE</Button>
          <Button onClick={downloadXml}>Baixar XML</Button>
          <Button onClick={sendEmail}>Enviar NFS-e por E-mail</Button>
        </>
      )}
      {canReverse && <Button onClick={reverseOrder}>Estorno</Button>}
    </ButtonGroup>
  ) : (
    <></>
  );
};

export default OrderActions;
